module.exports = __webpack_public_path__ + "img/12.05e8c7fa.jpg";